import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-password',
  templateUrl: './icon-password.component.html',
  styleUrls: ['./icon-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconPasswordComponent {}
